import * as React from 'react';
import { DisabledToggleIconContainer, DisabledToggleIconContent } from './components';

export const DisabledToggleIcon = () => (
  <DisabledToggleIconContainer>
    <DisabledToggleIconContent />
  </DisabledToggleIconContainer>
);
